import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { EventsService } from '../events.service';
import { RegistrationService } from '../../registration/shared/registration.service';
import { RegistrationSearchParams } from '../../registration/shared/registration-search-params.model';
import { AsyncState } from '../../../shared/model/index';
import { UtilService } from 'src/app/shared/util/util.service';

@Component({
  selector: 'wl-delete-event-modal',
  templateUrl: 'delete-event-modal.component.html',
  providers: [EventsService, RegistrationService],
    standalone: false
})
export class WlEventDeleteModalComponent {
  @Input() public eventId: number;
  @Output('closeComplete') public closeCompleteEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  public _checkedRegistrations: boolean = false;
  public _hasRegistrations: boolean = false;
  public _deleteSafetyOff: boolean = false;

  public checkingRegistrations: AsyncState = new AsyncState();
  public deleting: AsyncState = new AsyncState();
  public showModal = false;

  /**
   * Inject
   * @param _eventsService
   */
  public constructor(
    public _eventsService: EventsService,
    public _registrationService: RegistrationService,
    private _utilService: UtilService
  ) {
    this.eventId = 0;
  }

  /**
   * open the modal for this event id
   * @param eventId
   * @returns a promise that is resolved when the modal finishes opening
   */
  public open(eventId: number): Promise<void> {
    this.eventId = eventId;
    this.showModal = true;

    this.reset();

    this.checkEventForRegistrations();

    return Promise.resolve();
  }

  /**
   * close the modal
   * @returns a promise that is resolved when the modal finishes closing
   */
  public close(): Promise<void> {
    this.showModal = false;
    this.closeCompleteEmitter.emit(this.deleting.success);
    return Promise.resolve();
  }

  /**
   * reset variables for reuse
   */
  public reset(): void {
    this._deleteSafetyOff = false;
    this._checkedRegistrations = false;
    this.checkingRegistrations.busy = false;
    this.checkingRegistrations.message = '';
    this.deleting.busy = false;
    this.deleting.message = '';
  }

  /**
   * checks event for registrations and disables deleting if there are any.
   */
  public checkEventForRegistrations(): void {
    this._hasRegistrations = false;

    this.checkingRegistrations.busy = true;
    this.checkingRegistrations.message = '';

    let searchParams: RegistrationSearchParams = new RegistrationSearchParams();
    searchParams.EventId = this.eventId;
    searchParams.PageSize = 1;

    // check if there are registrations on this event
    this._registrationService.searchRegistrations(searchParams).then(
      (result) => {
        this.checkingRegistrations.busy = false;
        this.checkingRegistrations.success = true;

        if (result && result.TotalCount > 0) this._hasRegistrations = true;

        this._checkedRegistrations = true;
      },
      (error) => {
        this.checkingRegistrations.busy = false;
        this.checkingRegistrations.success = false;
        this.checkingRegistrations.message = this._utilService.extractErrorMessage(error);
      }
    );
  }

  /**
   * delete the event correlating to this.eventId
   */
  public deleteEvent() {
    this.deleting.busy = true;
    this.deleting.message = '';

    // delete
    this._eventsService.delete(this.eventId).then(
      (result) => {
        this.deleting.busy = false;
        this.deleting.success = true;

        // success, close
        this.close();
      },
      (error) => {
        this.deleting.busy = false;
        this.deleting.success = false;
        this.deleting.message = this._utilService.extractErrorMessage(error);
      }
    );
  }

  /**
   * triggered when use clicks cancel
   */
  public handleCancelClick(): void {
    this.close();
  }

  /**
   * Handles delete button click
   */
  public handleDeleteClick(): void {
    this.deleteEvent();
  }
}
